<dialog class="story-main-overlay" #dialogEl>
  <ng-container *ngIf="storyData">
    <div class="story" [ngClass]="['theme-' + (storyData.color ? storyData.color : '0'), 'gradient-' + storyData.gradient]">
      <div class="story__header">

        <div class="story__header-left">

        </div>

        <div class="story__header-center">
          <div class="story__user-avatar">
            <brt-story-avatar [image]="storyData.user.avatar" [progress]="progress"></brt-story-avatar>
          </div>

          <div class="story__headline">
            <span>Tagesablauf</span>
            <span [innerHTML]="storyData.title"></span>
          </div>

          <div class="story__progress-number">
            {{currentCardNumber}} / {{totalCardNumber}}
          </div>
        </div>


        <div class="story__toolbar">
          <div class="story__mobile-actions-trigger" brtItemActions [items]="mobileActionsMenu"><brt-icon [icon]="'dotting'"></brt-icon></div>
          <button role="button" class="story__share-button" (click)="onShareButtonClicked()"><brt-icon [icon]="'share'"></brt-icon></button>
          <button role="button" class="story__close-button" (click)="closeStory()"><brt-icon [icon]="'x-thin'"></brt-icon></button>
        </div>
      </div>

      <div class="story__main-content">
        <button role="button" aria-label="Slider zurück" class="story__navigation story__navigation--prev" (click)="goToPrevSlide()" *ngIf="!isFirstSlide"><brt-icon [icon]="'reg-arrow-left'"></brt-icon></button>

        <swiper [config]="sliderOptions" (init)="sliderInit($event)" (slideChange)="onSlideChanged($event)">
          <ng-template swiperSlide *ngFor="let card of storyData.cards; index as idx">
            <div class="story__card" (click)="goToSlide(idx)">
              <brt-card [card-data]="card" [story-data]="storyData" (cardTimeout)="goToNextSlide()" [current]="currentSlideIdx == idx" [attr.inert]="currentSlideIdx !== idx ? '' : null"></brt-card>
            </div>
          </ng-template>

          <ng-template swiperSlide>
            <div class="story__card" (click)="goToSlide(storyData.cards.length)">
              <brt-card>
                <brt-next-story-card [data]="storyData.nextStories" [attr.inert]="(currentSlideIdx !== storyData.cards.length) ? '' : null"></brt-next-story-card>
              </brt-card>
            </div>
          </ng-template>
        </swiper>

        <button role="button" aria-label="Slider weiter" class="story__navigation story__navigation--next" (click)="goToNextSlide()" *ngIf="!isLastSlide"><brt-icon [icon]="'reg-arrow-right'"></brt-icon></button>


      </div>

      <div class="story__footer">
        <brt-story-footer [story]="storyData" (onClosed)="closeStory()"></brt-story-footer>
      </div>

    </div>
  </ng-container>
</dialog>




